module.exports = __webpack_public_path__ + "static/media/xlsm.253ce67b.svg";